import { render, staticRenderFns } from "./pdfView.vue?vue&type=template&id=3a97765f&scoped=true&"
import script from "./pdfView.vue?vue&type=script&lang=js&"
export * from "./pdfView.vue?vue&type=script&lang=js&"
import style0 from "./pdfView.vue?vue&type=style&index=0&id=3a97765f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97765f",
  null
  
)

export default component.exports